// market — or. Part of the or i18n bundle; merged by ./index.js

export default {
  loading: "Fe'aa jira...",
  marketTitle: 'Magaalaa',
  marketSubtitle: 'Nabiyyee ulfaa daldalaa hundaa erga argamee daldalaan keessatti argamu — daalwaysii banaa, eegaa hin qabu.',
  bestDealToday: '⚡ Qabiyyee Gaafaa Kallatti Qabaa',
  bestDealsWeek: '🏆 Qabiyyeen Walqixaatoota Kennee Qabaa',
  endsIn: 'Xumurama',
// Bazaar & Market filter UI
  clearAll: 'Hundaa Cleeraa',
  searchLabel: 'Barbaadi',
  availability: 'Argamuu',
  inStockOnly: 'Qabeenya Qabu Qofa',
  allLocations: 'Naannoo Hundaa',
  sellers: 'Daldalaan',
  applyFilters: 'Filtarriihibi Hojiirgalo',
  sortDefault: 'Dinjilee: Wuunuu',
  sortNewest: 'Nuttaa Duraa',
  sortPriceAsc: 'Kaffaa: Dhibaa → Ol’aa',
  sortPriceDesc: 'Kaffaa: Ol’aa → Dhibaa',
  sortNameAsc: 'Maqaa: A → Z',
  statProducts: 'Nabiyyee',
  statCategories: 'Kutaa',
  statCities: 'Magaalaa',
  subcategoriesLabel: 'Kutaa Xiqqaa:',
  all: 'Hundaa',
  resultsNone: 'Filtarriihicha biraatiin daaranii argame hin qabu',
  resultsCount: (n) => `${n} oomishaalee`,
  resultsCountOf: (a, b) => `Oomishaalee ${b} keessatti ${a}`,
  priceUnder: (a) => `Kaffaa ${a} Birrii gabaabaa`,
  priceBand: (a, b) => `${a} – ${b} Birr`,
  priceOver: (a) => `Kaffaa ${a} Birrii ol’aa`,
  gridView: 'Fuula Maree',
  listView: 'Fuula Tarree',
  scrollCatLeft: 'Kutaalee harka ofiitti socho’aa',
  scrollCatRight: 'Kutaalee harka mirgaa socho’aa',
  marketPlaceWord: 'Bakka',
  marketTagline: 'Nabiyyeen hayyama waliin hundaa bakka tokkatti argamu — kutaa yookaan naannoo boordicha.',
  comingSoon: 'Garuu Dhufu',
  openNow: 'Banaa',
  closedNow: 'Cufaa',
// Bazaar open/closed + countdown
  opensIn: '⏳ Kannee Banaa',
  closesIn: '· Kannee Cufaa',
  nextBazaar: 'Baazara Kannee',
  closedPromoTitle: 'Kan Eegu Jirtu Kanii',
  closedPromoDesc: 'Baazaarni dhiyeessu ilaali — miidanni, daldalaanii, kutaa fi magaalota Itoophiyaa hunda irraa.',
  scheduledByAdmin: 'Adminnichiin Sagate',
  lastUpdated: 'Gulaalii Dhumaa',
  mpCatGridTitle: 'Kutaa Booddee Biraa Qabuu',
  mpCatGridViewAll: 'Hundaa Ilaali',
  signInToAdd: 'Oomishaalee kennee jiraa dabalafuufiin seenaa ta’uun qabdaa.',
  signInRequired: 'Seenaa Ta’uu Qabaa',
  wishlistLoginDesc: 'Oomishaalee kennee jiraa dabalafuufiidhaa fi bilisaa ta’uufiin seenaa ta’uu qabdaa.',
  cancel: 'Haqi Ture',
  soldOut: 'Caalamamee Jira',
  bundle: 'Buufuu',
  addedToWishlist: (name) => `❤️ ${name} wichii didaa keessatti dabalamee!`,
  searchProducts: 'Oomishaalee Barbaadi...',
  noResults: 'Oomishaaleen hin argamne.',
};
